export default __webpack_public_path__ + "static/media/gallery03.46b8eddf.jpg";